<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"> </p>
<p class="copy"> </p>
<p class="copy">This edition first published in 2005</p>
<p class="copy1">First published in 2001 by</p>
<p class="copy">New Holland Publishers (UK) Ltd</p>
<p class="copy">London • Cape Town • Sydney • Auckland</p>
<p class="copy1">Garfield House</p>
<p class="copy">86–88 Edgware Road</p>
<p class="copy">London W2 2EA</p>
<p class="copy">United Kingdom</p>
<p class="copy1">80 McKenzie Street</p>
<p class="copy">Cape Town 8001</p>
<p class="copy">South Africa</p>
<p class="copy1">Level 1, Unit 4, 14 Aquatic Drive</p>
<p class="copy">Frenchs Forest, NSW 2086</p>
<p class="copy">Australia</p>
<p class="copy1">218 Lake Road</p>
<p class="copy">Northcote, Auckland</p>
<p class="copy">New Zealand</p>
<p class="copy1">Copyright © 2001 in text Cassie Maroun-Paladin</p>
<p class="copy">Copyright © 2001 in photographs John Peacock, 1997</p>
<p class="copy">Copyright © 2001 New Holland Publishers (UK) Ltd</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without the prior written permission of the publishers and copyright holders.</p>
<p class="copy1">Print ISBN 1 84537 187 9<br/>eISBN 978 1 84537 187 6</p>
<p class="copy1">Designed by Roger Hammond</p>
<p class="copy1">Reproduction by PICA Digital PTE Ltd, Singapore</p>
<p class="copyc"> </p>
<p class="copyc"><strong>Important</strong></p>
<p class="copyc">In the recipes, use either metric or imperial measurements, but never a combination of the two, as exact conversions are not always possible. Every effort has been made to present clear and accurate instructions. Therefore, the author and publishers can accept no liability for any injury, illness or damage which may inadvertently be caused to the user whilst following these instructions.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?47f8a014